module.exports = require("legacy-swc-helpers/lib/_to_consumable_array.js")